import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './style.css'

console.log('[legacy-app] main.jsx executing')
window.__reactRenderAvailable = true

var root = document.getElementById('root')
if (root) {
  createRoot(root).render(<App />)
  console.log('[legacy-app] App mounted on #root')
}
